module.exports = __webpack_public_path__ + "img/children_1.bca9fb9b.jpg";